import { render, staticRenderFns } from "./Template13.vue?vue&type=template&id=99230db6&scoped=true&"
import script from "./Template13.vue?vue&type=script&lang=js&"
export * from "./Template13.vue?vue&type=script&lang=js&"
import style0 from "./Template13.vue?vue&type=style&index=0&id=99230db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99230db6",
  null
  
)

export default component.exports